const FeedItem = ({ quote }) => {
  return (
    <div className="h-full flex flex-col">
      <style>{`
        .quote-scroll::-webkit-scrollbar { display: none; }
        .quote-scroll { scrollbar-width: none; -ms-overflow-style: none; }
      `}</style>

      {quote ? (
        <div
          className="quote-scroll h-full rounded-[20px] px-5 pt-4 pb-5 overflow-y-auto flex flex-col gap-3"
          style={{
            background: "linear-gradient(160deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)",
            border: "1px solid rgba(255,255,255,0.07)",
          }}
        >
          <span className="text-[10px] font-semibold text-white/30 uppercase tracking-[0.15em] shrink-0">
            Caption
          </span>
          <p
            className="text-white font-bold leading-tight flex-1"
            style={{
              fontSize: "clamp(1.25rem, 4vw, 1.65rem)",
              letterSpacing: "-0.01em",
              wordBreak: "break-word",
            }}
          >
            {quote}
          </p>
        </div>
      ) : (
        <div className="h-full flex items-center justify-center">
          <span className="text-white/20 text-sm">No caption</span>
        </div>
      )}
    </div>
  );
};

export default FeedItem;
